export const schoolSubjectGroupKeys = {
  all: ['schoolSubjectGroup'],

  lists: () => [...schoolSubjectGroupKeys.all, 'list'],

  tenantList: (tenantId?: number) => [...schoolSubjectGroupKeys.lists(), 'tenant', tenantId ?? null],

  classList: (classId: number | undefined) => [...schoolSubjectGroupKeys.lists(), 'class', classId],

  byTemplateSet: (templateSetId: number | null, schoolLevel: number | null) => [
    ...schoolSubjectGroupKeys.lists(),
    'templates',
    'byTemplateSet',
    templateSetId,
    schoolLevel,
  ],

  tenantTemplates: (hasTenantAdminAccess: boolean) => [
    ...schoolSubjectGroupKeys.lists(),
    'tenant-template',
    hasTenantAdminAccess,
  ],

  providerTemplates: (templateSetId: number | undefined, hasProviderAccess: boolean, schoolLevel?: number) => [
    ...schoolSubjectGroupKeys.lists(),
    'provider-template',
    templateSetId,
    hasProviderAccess,
    ...(schoolLevel == null ? [] : [{ schoolLevel }]),
  ],
};
